/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_OverlineInputs */

const en_mk_studio_overline = /** @type {(inputs: Mk_Studio_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYSTEP STUDIO`)
};

const id_mk_studio_overline = /** @type {(inputs: Mk_Studio_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYSTEP STUDIO`)
};

/**
* | output |
* | --- |
* | "BYSTEP STUDIO" |
*
* @param {Mk_Studio_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_overline = /** @type {((inputs?: Mk_Studio_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_overline(inputs)
	return en_mk_studio_overline(inputs)
});